<template>
  <div class="menus" @keyup.13="submit">
    <mu-dialog
      title="权限管理"
      width="800"
      :open="open"
      @close="close"
      scrollable
    >
      <Tree
        :list="allMenuList"
        :selectedMenuList="form.menus"
        @treeChange="treeChange"
      ></Tree>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
import Tree from '@/components/tree'
export default {
  components: { Tree },
  props: {
    open: {
      tpye: Boolean,
      default: false
    },
    form: {
      type: Object
    }
  },
  data() {
    return {
      allMenuList: []
    }
  },
  methods: {
    submit() {
      backend(api.role.update, this.form).then((result) => {
        if (result.statusCode === 200) {
          this.$toast.success('设置成功')
          this.close()
          this.$emit('finish')
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    },
    getAllMenu() {
      backend(api.menu.getTree).then((result) => {
        if (result.statusCode === 200) {
          this.allMenuList = result.data
        }
      })
    },
    treeChange(data) {
      this.$emit('treeChange', data)
    }
  },
  mounted() {
    this.getAllMenu()
  }
}
</script>

<style lang="less" scoped>
.menus {
}
</style>



// WEBPACK FOOTER //
// src/views/role/menus.vue